var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.75V9L12.25 11.25",
    stroke: "#2762F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.75V9L12.25 11.25",
    stroke: "#279EF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.75C13.004 1.75 16.25 4.996 16.25 9C16.25 13.004 13.004 16.25 9 16.25",
    stroke: "#2762F5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.75C13.004 1.75 16.25 4.996 16.25 9C16.25 13.004 13.004 16.25 9 16.25",
    stroke: "#279EF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87299 14.877C4.2872 14.877 4.62299 14.5412 4.62299 14.127C4.62299 13.7128 4.2872 13.377 3.87299 13.377C3.45877 13.377 3.12299 13.7128 3.12299 14.127C3.12299 14.5412 3.45877 14.877 3.87299 14.877Z",
    fill: "#2762F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87299 14.877C4.2872 14.877 4.62299 14.5412 4.62299 14.127C4.62299 13.7128 4.2872 13.377 3.87299 13.377C3.45877 13.377 3.12299 13.7128 3.12299 14.127C3.12299 14.5412 3.45877 14.877 3.87299 14.877Z",
    fill: "#279EF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.75C2.16421 9.75 2.5 9.41421 2.5 9C2.5 8.58579 2.16421 8.25 1.75 8.25C1.33579 8.25 1 8.58579 1 9C1 9.41421 1.33579 9.75 1.75 9.75Z",
    fill: "#2762F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.75C2.16421 9.75 2.5 9.41421 2.5 9C2.5 8.58579 2.16421 8.25 1.75 8.25C1.33579 8.25 1 8.58579 1 9C1 9.41421 1.33579 9.75 1.75 9.75Z",
    fill: "#279EF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87299 4.62299C4.2872 4.62299 4.62299 4.2872 4.62299 3.87299C4.62299 3.45877 4.2872 3.12299 3.87299 3.12299C3.45877 3.12299 3.12299 3.45877 3.12299 3.87299C3.12299 4.2872 3.45877 4.62299 3.87299 4.62299Z",
    fill: "#2762F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87299 4.62299C4.2872 4.62299 4.62299 4.2872 4.62299 3.87299C4.62299 3.45877 4.2872 3.12299 3.87299 3.12299C3.45877 3.12299 3.12299 3.45877 3.12299 3.87299C3.12299 4.2872 3.45877 4.62299 3.87299 4.62299Z",
    fill: "#279EF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22601 16.448C6.64023 16.448 6.97601 16.1122 6.97601 15.698C6.97601 15.2838 6.64023 14.948 6.22601 14.948C5.8118 14.948 5.47601 15.2838 5.47601 15.698C5.47601 16.1122 5.8118 16.448 6.22601 16.448Z",
    fill: "#2762F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22601 16.448C6.64023 16.448 6.97601 16.1122 6.97601 15.698C6.97601 15.2838 6.64023 14.948 6.22601 14.948C5.8118 14.948 5.47601 15.2838 5.47601 15.698C5.47601 16.1122 5.8118 16.448 6.22601 16.448Z",
    fill: "#279EF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.302 12.524C2.71622 12.524 3.052 12.1882 3.052 11.774C3.052 11.3598 2.71622 11.024 2.302 11.024C1.88779 11.024 1.552 11.3598 1.552 11.774C1.552 12.1882 1.88779 12.524 2.302 12.524Z",
    fill: "#2762F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.302 12.524C2.71622 12.524 3.052 12.1882 3.052 11.774C3.052 11.3598 2.71622 11.024 2.302 11.024C1.88779 11.024 1.552 11.3598 1.552 11.774C1.552 12.1882 1.88779 12.524 2.302 12.524Z",
    fill: "#279EF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.302 6.97601C2.71622 6.97601 3.052 6.64023 3.052 6.22601C3.052 5.8118 2.71622 5.47601 2.302 5.47601C1.88779 5.47601 1.552 5.8118 1.552 6.22601C1.552 6.64023 1.88779 6.97601 2.302 6.97601Z",
    fill: "#2762F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.302 6.97601C2.71622 6.97601 3.052 6.64023 3.052 6.22601C3.052 5.8118 2.71622 5.47601 2.302 5.47601C1.88779 5.47601 1.552 5.8118 1.552 6.22601C1.552 6.64023 1.88779 6.97601 2.302 6.97601Z",
    fill: "#279EF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22601 3.052C6.64023 3.052 6.97601 2.71622 6.97601 2.302C6.97601 1.88779 6.64023 1.552 6.22601 1.552C5.8118 1.552 5.47601 1.88779 5.47601 2.302C5.47601 2.71622 5.8118 3.052 6.22601 3.052Z",
    fill: "#2762F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22601 3.052C6.64023 3.052 6.97601 2.71622 6.97601 2.302C6.97601 1.88779 6.64023 1.552 6.22601 1.552C5.8118 1.552 5.47601 1.88779 5.47601 2.302C5.47601 2.71622 5.8118 3.052 6.22601 3.052Z",
    fill: "#279EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentClock);
export default __webpack_public_path__ + "static/media/recent-clock.900bf1284bfe2fa60768f514e21a238f.svg";
export { ForwardRef as ReactComponent };